<template lang="pug">
    span(v-f="", data-tooltip='', aria-haspopup="true", data-disable-hover="false", :tabindex="_uid", :title="tip", :data-click-open="open", :class="position").has-tip
        slot
</template>

<script type="text/babel">
    export default {
        name: "FoundationTooltip",
        props: [
            'tip',
            'open',
            'position'
        ]
    }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Tooltip.vue?20ef4aa9